import React from "react";
import { Navigate, Redirect } from "react-router-dom";

const CodeVilleGalleryPage = () => {
  return <Navigate to="/codeville/gallery/junior-academy" />;
};

export { CodeVilleGalleryPage };
export * from "./JuniorAcademy";
export * from "./KidsCodeCamp";